export const BUS_EVENTS = {
  SET_REFERRER_HOST: 'SET_REFERRER_HOST',
  SET_TWEET_REPLY: 'SET_TWEET_REPLY',
  ATTACHMENT_SIZE_CHECK_ERROR: 'ATTACHMENT_SIZE_CHECK_ERROR',
};
